import { defineComponent as _defineComponent } from 'vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import { FireOutbreakReactionOptionsFactory } from '../factories/FireOutbreakReactionOptions.factory'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakCardReactionMenu',
  props: {
    alert: null,
    paintIcon: { type: Boolean, default: true }
  },
  emits: ["reaction"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'reaction', value: FireOutbreakReactionEnum): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { alert: FireOutbreak, paintIcon: boolean };





const icon = computed(() => {
	switch (props.alert.reaction) {
		case FireOutbreakReactionEnum.POSITIVE:
			return 'material-symbols:thumb-up-rounded'
		case FireOutbreakReactionEnum.NEGATIVE:
			return 'material-symbols:thumb-down-rounded'
		case FireOutbreakReactionEnum.IMPOSSIBLE:
			return 'fa7-solid:question'
		default:
			return 'material-symbols:thumb-up-outline-rounded'
	}
})

const iconColor = computed(() => {
	if (!props.paintIcon) return 'text-blue-base'
	return props.alert.seen ? 'text-blue-base' : 'text-red-danger'
})

return { __sfc: true,props, emit, icon, iconColor, ContextMenu, FireOutbreakReactionOptionsFactory }
}

})